<template>
<div class="chapter">
<div class="inner_page">
      ﻿
<title>THE STORY DEVOTIONAL</title><link href="css/default.css" rel="stylesheet" type="text/css"/>
<p class="ctp" id="p0014-01-0"><a id="page8"></a><a href="#/contents#fn_7" id="sn_7">DAY 7</a></p>
<p class="ct"><a href="#/contents#fn_7">THE BEST FOR LAST</a></p>
<p class="ext"><i>God blessed [the man and the woman] and said to them, “Be fruitful and increase in number; fill the earth and subdue it. </i></p>
<p class="ext1"><i>God saw all that he had made, and it was very good. And there was evening, and there was morning—the sixth day.</i></p>
<p class="txr"><span><span class="small">GENESIS</span> 1:28, 31</span></p>
<p class="tx1" id="p0014-04-5"><span class="dcap">M</span>aybe you’ve noticed the chorus in Genesis 1—“And God saw that it was good.” Of course our perfect and infinitely wise, powerful, and good God would make his creation “good.”</p>
<p class="tx">But did you notice the variation on that chorus? After the Lord completed his creative efforts, he made human beings in his image, he blessed us with the responsibility of caring for his creation, and he pronounced his work “very good.”</p>
<p class="tx">Yes, God definitely saved his best creation for last. Human beings have been called the crown of his creation. As such, we are blessed with the opportunity to be in relationship with the Holy and Eternal One, our Savior and Redeemer. And that privilege to be in relationship with God—to be welcomed by God as his friend and his child—is also “very good.”</p>
<p class="tx2">YOU ARE GOD’S HANDCRAFTED CREATION, ONE OF HIS MASTERPIECES.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter10.vue?099bd5fe